

import { Vue, Component } from "vue-property-decorator";
import { regionData } from "element-china-area-data";
import areaArr from "@/components/world.js";
	export default {
	    data() {
	      return {
			url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
			options : regionData,
			value: [[17,18,19],[1,7,10],[1,2,3]],
			options1: [{
			  value1: '选项1',
			  label1: '股份有限公司'
			}, {
			  value1: '选项2',
			  label1: '有限责任公司'
			}],
			value1: '',
			pics:[
				'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
			],
			dialogVisible:false,
			dialogTitle:'',
			productAttrCate:{
			  name:'',
			  id:null
			},
			selectReasons:[],
			reasons:[
				'名称重叠',
				'身份证号错误',
				'无法联系申请人',
				'地址与营业地址不统一',
				'主体模糊',
				'信用代码模糊',
				'身份证照片模糊',
				'商标存在纠纷'
			],
			checkAll: false,
			isIndeterminate: true,
			textarea:'',
			
	        ruleForm: {},
	        rules: {
	          name: [
	            { required: true, message: '请输入活动名称', trigger: 'blur' },
	            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
	          ],
	          region: [
	            { required: true, message: '请选择活动区域', trigger: 'change' }
	          ],
	          date1: [
	            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
	          ],
	          date2: [
	            { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
	          ],
	          type: [
	            { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
	          ],
	          resource: [
	            { required: true, message: '请选择活动资源', trigger: 'change' }
	          ],
	          desc: [
	            { required: true, message: '请填写活动形式', trigger: 'blur' }
	          ]
	        }
	      };
	    },
		mounted() {
		  let datas = {};
		  let paramter = {};
		  let id = this.$route.query.id;
		  this.$http.post("shop/"+id, {}).then((res: any) => {
		  	datas = res.data.data;
		  	this.ruleForm = datas;
		  });
		},
	    methods: {
			
			// 商家审核接口
		  checkFirmData(reasonTep,resultTep,typeTep){
			  
			  let datas = {};
			  let reason = reasonTep;
			  let result = resultTep;
			  let shopId = this.$route.query.id;
			  let type = typeTep;
			  let paramter = {
				  reason,
				  result,
				  shopId,
				  type
			  };
			  let id = this.$route.query.id;
			  let messageTemp;
			  if(result == 1){
				  
				  messageTemp = '审核通过!';
			  } else{
				  
				  messageTemp = '审核不通过!';
			  }
			  this.$http.post("shop/check/"+id, paramter).then((res: any) => {
			  	this.$message({
			  	    message: messageTemp,
			  	    type: 'success'
			  	});
			  	this.$router.back();
			  });
		  },
	      submitForm(formName) {
	        this.$refs[formName].validate((valid) => {
	          if (valid) {
	            alert('submit!');
	          } else {
	            console.log('error submit!!');
	            return false;
	          }
	        });
	      },
	      resetForm(formName) {
	        this.$refs[formName].resetFields();
	      },
		  handleChange(){
			  //选择地区
		  },
		  handleCancel(){
			  
			  //取消
			  this.$router.back();
		  },
		  handleNoCheck(){
		  			  
		  	// 审核不通过
			this.dialogVisible = true;
			
		  },
		  handleSuccessCheck(){
		  			  
		  	// 审核成功
			this.checkFirmData('','1','1');	 
			
		  },
		  handleSureEdit(){
		  	
		  	// 确认编辑
			this.$message({
			    message: '恭喜你，这是一条成功消息',
			    type: 'success'
			});
		  },
		  handleClose(){
			// 关闭弹框
			this.dialogVisible = false;
		  },
		  sureSubmit(value){
			  
			// 确认弹框
			this.dialogVisible = false;
			this.checkFirmData(value,'0','1');	
		  },
		  handleReasonsChange(value){
			  
			//审核原因
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.reasons.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.reasons.length;
			console.log(value);
			this.selectReasons = value;
			let tempText = '';
			for (let i in this.selectReasons) {
			    console.log(i); 	//打印结果为books的索引
				let integer = parseFloat(i)+ 1;
			    tempText += integer+'.'+this.selectReasons[i]+',';
			}
			this.textarea = tempText;

		  }
	    }
	  }
